export default __webpack_public_path__ + "static/media/pre-login-bookdoc-logo@2x.8b726b14.png";